import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getCustomerOrders } from "../../api/apiCustomers";

export const useGetCustomerOrders = (id, params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["customer-orders", id, params, i18next.language],
        queryFn: () => getCustomerOrders(id, params),
        enabled: !!id,
        keepPreviousData: true,
    });

    const root = data?.data;
    let orders = [];
    let meta = data?.meta;
    if (Array.isArray(root)) {
        orders = root;
    } else if (root && Array.isArray(root.data)) {
        orders = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        orders,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: orders.length },
        refetch,
    };
};
